const kfCenterList = [{
        path: "/consultingService_one",
        name: "consultingService_one",
        component: () =>
            import ("@/views/kfCenter/consultingService_one.vue"),
        meta: {
            title: "热门问题"
        }
    },
    {
        path: "/consultingService_oneDetail",
        name: "consultingService_oneDetail",
        component: () =>
            import ("@/views/kfCenter/consultingService_oneDetail.vue"),
        meta: {
            title: "问题列表"
        }
    },
    {
        path: "/consultingService_two",
        name: "consultingService_two",
        component: () =>
            import ("@/views/kfCenter/consultingService_two.vue"),
        meta: {
            title: "热门问题"
        }
    },
    {
        path: "/consultingService_three",
        name: "consultingService_three",
        component: () =>
            import ("@/views/kfCenter/consultingService_three.vue"),
        meta: {
            title: "热门问题"
        }
    },
    {
        path: "/consultingService_four",
        name: "consultingService_four",
        component: () =>
            import ("@/views/kfCenter/consultingService_four.vue"),
        meta: {
            title: "客服中心"
        }
    }, {
        path: "/consultingService_jump",
        name: "consultingService_jump",
        component: () =>
            import ("@/views/kfCenter/consultingService_jump.vue"),
        meta: {
            title: "跳转"
        }
    }

];
export default kfCenterList;